import { oz } from '@weft/utils';
import { NOTIFICATION_EVENT_TYPES } from '../../notification-subscription/notification-event-type-schema';
import { BaseNotificationSchema } from '../base-notification-schema';
import { AnonymousNotificationMetadataSchema } from '../notification-metadata-schemas/anonymous-customer-metadata-schema';

export const AnonymousCustomerNotificationSchema = BaseNotificationSchema.extend({
  eventType: oz.literal(NOTIFICATION_EVENT_TYPES.AnonymousCustomer),
  metadata: AnonymousNotificationMetadataSchema,
}).openapi('AnonymousCustomerNotification');

export type AnonymousCustomerNotification = oz.infer<typeof AnonymousCustomerNotificationSchema>;